import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import ReservationsTable from './ReservationsTable';
import { Link } from 'react-router-dom';

const Reservations = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Reservations" title="Reservations" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Reservations</H5>
                <Link to="/reservations/new">
                  <Btn color="primary">New reservation</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <ReservationsTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Reservations;
